module.exports = __webpack_public_path__ + "static/media/step_6.9c15cd8a.mp3";